
const baseRoute = [
  {
    path: '/',
    name: 'home',
    meta: {
      auth: false, // 是否登录状态下可访问
      keepAlive: false // 是否缓存页面
    },
    component: () => import('@/views/Home/Home.vue')
  },
  {
    path: '/phoneSolution', // 解决方案
    name: 'phoneSolution',
    meta: {
      auth: false,
      keepAlive: false
    },
    component: () => import('@/views/Solution/phoneSolution.vue')
  },
  {
    path: '/petSolution', // 解决方案
    name: 'petSolution',
    meta: {
      auth: false,
      keepAlive: false
    },
    component: () => import('@/views/Solution/petSolution.vue')
  },
  {
    path: '/householdSolution', // 解决方案
    name: 'householdSolution',
    meta: {
      auth: false,
      keepAlive: false
    },
    component: () => import('@/views/Solution/householdSolution.vue')
  },
  {
    path: '/otherSolution', // 解决方案
    name: 'otherSolution',
    meta: {
      auth: false,
      keepAlive: false
    },
    component: () => import('@/views/Solution/otherSolution.vue')
  },
  {
    path: '/customer', // 客户及合作案例
    name: 'Customer',
    meta: {
      auth: false,
      keepAlive: false
    },
    component: () => import('@/views/Customer/Customer.vue')
  },
  {
    path: '/aboutUs', // 走进中保
    name: 'AboutUs',
    meta: {
      auth: false,
      keepAlive: false
    },
    component: () => import('@/views/AboutUs/AboutUs.vue')
  },
  {
    path: '/article', // 文章
    name: 'Article',
    meta: {
      auth: false,
      keepAlive: false
    },
    component: () => import('@/views/AboutUs/Article.vue')
  },
  {
    path: '/newsList', // 文章列表
    name: 'NewsList',
    meta: {
      auth: false,
      keepAlive: false
    },
    component: () => import('@/views/AboutUs/NewsList.vue')
  }

]
export default baseRoute
